import "./WorkingOnIt.module.css";
import Header from "@/reusable_sections/Header";
import PageHero from "./sections/PageHero";
import Footer from "@/reusable_sections/Footer";
export default function WorkingOnItPage() {
  return <div>
      <Header />
      <PageHero />
      <Footer />
    </div>;
}